<template>
  <div>
    <div>
      <v-btn v-if="proposals_id_stack.length > 0" style="background-color: #E57373 !important; border-color: #E57373 !important;" @click="back_proposal()">
        <v-icon>mdi-arrow-left-top-bold</v-icon> Назад
      </v-btn>
      <v-btn class="primary" @click="close_proposal_dialog()">
        <v-icon>mdi-close</v-icon> Закрыть
      </v-btn>
    </div>

    <v-card v-if="(GETTERS_INPUT_ALL !== null) && (GETTERS_INPUT_ALL !== undefined)" class="main-card">
      <v-card-title text-color="#15336d">
        <v-icon left color="#15336d">mdi-label</v-icon>
        №{{GETTERS_INPUT_ALL.id}} {{GETTERS_INPUT_ALL.name}}
      </v-card-title>
      <div class="pl-10 pb-2" v-if="GETTERS_INPUT_ALL.keywords && GETTERS_INPUT_ALL.keywords.length > 0">
        <b>{{GETTERS_INPUT_ALL.keywords}}</b>
      </div>
      <div class="d-flex flex-nowrap justify-space-between">
        <div style="width:70%;">
          <v-card-text style="margin-bottom: 15px; margin-left: 15px;">
            <v-expansion-panels
              multiple
              v-model="opened_panels"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-clipboard-text</v-icon>
                    {{$t('scientific-content.text')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="GETTERS_INPUT_ALL.problem_formulation"
                >
                  <span v-html="_updateText(GETTERS_INPUT_ALL.problem_formulation)"></span>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>{{$t('ModalCard.no_scientific_content')}}</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-clipboard-text</v-icon>
                    {{$t('scientificBackground.text')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="GETTERS_INPUT_ALL.background"
                ><span v-html="_updateText(GETTERS_INPUT_ALL.background)"></span></v-expansion-panel-content>
                <v-expansion-panel-content v-else>{{$t('ModalCard.scientific_groundwork_formulated')}}</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-clipboard-text</v-icon>
                    {{$t('ModalCard.expected_results')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="GETTERS_INPUT_ALL.expected_results"
                ><span v-html="_updateText(GETTERS_INPUT_ALL.expected_results)"></span></v-expansion-panel-content>
                <v-expansion-panel-content v-else>{{$t('ModalCard.no_results_formulated')}}</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-flask</v-icon>
                    {{$t('ModalCard.samples')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12">
                      <span>{{ GETTERS_INPUT_ALL.sample_description ? GETTERS_INPUT_ALL.sample_description : 'Описание образцов отсутствует' }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <div v-for="(item, i) in GETTERS_SAMPLETYPES">
                        <span>
                          <v-icon v-if="item.id == GETTERS_INPUT_ALL.sample_type_id">mdi-checkbox-marked-circle</v-icon>
                          <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                          {{item.name}}
                          <br />
                        </span>
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <span>
                        Количество образцов: {{GETTERS_INPUT_ALL.sample_count ? GETTERS_INPUT_ALL.sample_count : "не указано"}}
                        <br />
                      </span>
                      <span v-if="GETTERS_INPUT_ALL.sample_avarage_size">
                        Средний размер: {{GETTERS_INPUT_ALL.sample_avarage_size}} мм
                        <br />
                      </span>
                      <span v-if="GETTERS_INPUT_ALL.sample_surface_area">
                        Площадь поверхности: {{GETTERS_INPUT_ALL.sample_surface_area}} мм<sup>2</sup>
                        <br />
                      </span>
                      <span v-if="GETTERS_INPUT_ALL.sample_volume">
                        Объем: {{GETTERS_INPUT_ALL.sample_volume}} мм<sup>3</sup>
                        <br />
                      </span>
                      <span v-if="GETTERS_INPUT_ALL.sample_mass">
                        Масса образца: {{GETTERS_INPUT_ALL.sample_mass}} мг
                        <br />
                      </span>
                    </v-col>

                    <v-col cols="4">
                      <v-row>
                        <v-switch
                          x-small
                          color="red"
                          hide-details
                          v-model="GETTERS_INPUT_ALL.is_biohazard"
                          disabled
                          :label="$t('biologicalDanger.text')"
                        ></v-switch>
                      </v-row>
                      <v-row>

                        <v-switch
                          x-small
                          color="red"
                          hide-details
                          v-model="GETTERS_INPUT_ALL.is_toxic"
                          disabled
                          :label="$t('toxicityLabel.text')"
                        ></v-switch>
                      </v-row>
                      <v-row>

                        <v-switch
                          x-small
                          color="red"
                          hide-details
                          v-model="GETTERS_INPUT_ALL.is_different_dangerous"
                          disabled
                          :label="$t('otherDanger.text')"
                        ></v-switch>
                      </v-row>

                      <v-row class="pl-10 pt-2" v-if="GETTERS_INPUT_ALL.is_different_dangerous">
                        <span>
                          <v-icon>mdi-radioactive</v-icon>
                          {{GETTERS_INPUT_ALL.other_dangers}}
                          <br />
                        </span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-clipboard-text</v-icon>
                    {{$t('experimentPlan.text')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="GETTERS_INPUT_ALL.experiment_strategy"
                ><span v-html="_updateText(GETTERS_INPUT_ALL.experiment_strategy)"></span></v-expansion-panel-content>
                <v-expansion-panel-content v-else>{{$t('ModalCard.no_experiment_plan')}}</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-comment-text-outline</v-icon>
                    {{$t('ModalCard.publications')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="GETTERS_INPUT_ALL.team_publications"
                >{{GETTERS_INPUT_ALL.team_publications}}</v-expansion-panel-content>
                <v-expansion-panel-content v-else>{{$t('ModalCard.there_publications')}}</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-engine-outline</v-icon>
                    {{$t('ModalCard.equipment_label')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <b>
                    <!-- <v-icon>mdi-clipboard-text</v-icon> -->
                    оборудование станции:
                  </b>
                  <br>
                  <div v-if="GETTERS_INPUT_ALL.additional_equipment" v-for="(addit_eq, k) in GETTERS_INPUT_ALL.additional_equipment" class="ml-3">
                    <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                    {{addit_eq.name}} <br>
                  </div>
                  <div v-else class="ml-3">
                    {{$t('ModalCard.additional_equipment_missing')}}
                  </div>

                  <hr class="mt-2">
                  <b>
                    <!-- <v-icon>mdi-clipboard-text</v-icon> -->
                    оборудования заявителя:
                  </b>
                  <br>
                  <div class="ml-3">
                    <span v-html="_updateText(GETTERS_INPUT_ALL.applicant_equipment)" v-if="GETTERS_INPUT_ALL.applicant_equipment"></span>
                      <span v-else> - </span>
                  </div>

                  <hr class="mt-2">
                  <b>
                    <!-- <v-icon>mdi-clipboard-text</v-icon> -->
                    данные по оборудованию для мат.пропуска:
                  </b>
                  <template v-if="can_bs_edit && !eqiupment_edit_mode">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ma-2"
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="red lighten-1"
                          @click="applicant_equipment_approved_new = GETTERS_INPUT_ALL.applicant_equipment_approved ? GETTERS_INPUT_ALL.applicant_equipment_approved : '' ; eqiupment_edit_mode = true">
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span> изменить </span>
                    </v-tooltip>
                    <br>
                    <div class="ml-3">
                      <p v-html="_updateText(GETTERS_INPUT_ALL.applicant_equipment_approved)" v-if="GETTERS_INPUT_ALL.applicant_equipment_approved"></p>
                      <p v-else> - </p>
                    </div>

                  </template>
                  <template v-if="eqiupment_edit_mode">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ma-2"
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="green lighten-1"
                          @click="change_applicant_equipment(true)">
                          mdi-check-underline
                        </v-icon>
                      </template>
                      <span> сохранить </span>
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ma-2"
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="red lighten-1"
                          @click="eqiupment_edit_mode = false">
                          mdi-close
                        </v-icon>
                      </template>
                      <span> отменить </span>
                    </v-tooltip>
                    <br>
                    <div class="ml-3">
                      <v-textarea
                        v-model="applicant_equipment_approved_new"
                        outlined
                        placeholder="укажите наименование, инв.номер и другую необходимую информацию"
                        type="number"
                        counter="500"
                        maxLength="500"
                        rows="2"
                      ></v-textarea>
                    </div>
                  </template>

                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-account-multiple</v-icon>
                    {{$t('ModalCard.team_and_calendar')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <Schedule-proposal-card
                    @loadEditable="load_editable()"
                    @reloadParent="$emit('reloadParent')"
                    @reloadLists="$emit('reloadLists')"
                    @reloadCalendar="$emit('reloadCalendar')"

                    :id="GETTERS_INPUT_ALL.id"
                    :status_id="GETTERS_INPUT_ALL.last_status_id"
                    :idProposal="GETTERS_INPUT_ALL.id"
                    :editable="editable"
                    :from_pass_card="from_pass_card"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

  <!-- FILES           -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-attachment</v-icon>
                    {{$t('ModalCard.attached_files')}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <v-list-item v-if="GETTERS_INPUT_ALL.files.length === 0">{{$t('ModalCard.absent')}}</v-list-item>
                    <template v-else>
                      <v-list-item v-for="item in GETTERS_INPUT_ALL.files" v-if="item.is_active == true" :key="item.id">
                        <v-list-item-avatar @click="openFile(item.name)">
                          <v-icon left>mdi-file</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-if="item.type == 1 || item.type == 2" @click="openFile(item.name)">
                            <v-badge color="red lighten-2" :content="item.type==1 ? 'Отчет' : 'Публикация'" x-small inline>
                              <p style="margin-bottom: 0px;">{{ item.name.length === 0 ? $t('untitled') : item.name.split('/').reverse()[0] }}</p>
                            </v-badge>
                          </v-list-item-title>
                          <v-list-item-title v-else v-text="item.name.length === 0 ? $t('untitled') : item.name.split('/').reverse()[0]" @click="openFile(item.name)">
                          </v-list-item-title>
                          <v-list-item-subtitle v-text="g.toDate(item.add_date)"/>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.name.length !== 0">
                          <v-btn @click="openFile(item.name)" icon>
                            <v-icon color="grey lighten-1">mdi-download</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
              
  <!-- BS COMMENT BLOCK START  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>
                    <v-icon>mdi-comment-processing-outline</v-icon>
                    {{$t('comment')}}
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          style="cursor:help;"
                        >
                          <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Заявитель не видит комментарии. Они доступны только ответственным по станции, модераторам и экспертам</span>
                    </v-tooltip>
                  </b>
                  
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <v-list-item class="pl-4">
                      <v-text-field
                        v-model.trim="commentBsCard"
                        append-outer-icon="mdi-send"
                        @click:append-outer="addCommentBs"
                        :loading="loadingComment"
                        label="Введите сообщение"
                      ></v-text-field>
                    </v-list-item>
                    <div class="comment-bs" v-if="GETTERS_INPUT_ALL.comments.length !== 0">
                      <v-list-item
                        v-for="(item, i) in GETTERS_INPUT_ALL.comments"
                        :key="i"
                        style="min-height: 0px !important;"
                        class="d-flex flex-column align-start justify-center mb-4"
                      >
                        <v-card width="100%" :class="comment_background_color(item)" class="pl-2">
                          <div class="d-flex align-center flex-wrap">
                            <strong>
                              {{item.author_name}}
                            </strong>
                            <v-chip
                              :color="$mainColor"
                              x-small
                              style="color: white !important;"
                              class="ma-2"
                            >
                              {{item.author_role}}
                            </v-chip>
                            <v-chip
                              v-if="item.kind === 'bs' && item.bs_resolution > 0"
                              :color="item.bs_resolution == 1 ? 'red' : 'green' "
                              x-small
                              style="color: white !important;"
                              class="ma-2"
                            >
                              {{item.bs_resolution == 1 ? $t('Actions.experiment_impossible') : $t('Actions.experiment_possible')}}
                            </v-chip>
                            <v-chip
                              :color="$mainColor"
                              class="ma-2"
                              x-small
                              style="color: white !important;"
                            >
                              {{g.toDate(item.created_at)}}
                            </v-chip>
                          </div>
                          <p style="color: red;">{{item.text | filterEmpty}}</p>
                        </v-card>
                      </v-list-item>
                    </div>
                    
                    <v-list-item v-else class="comment-bs" >
                      {{$t('BsList.bs_no_comments')}}
                    </v-list-item>
                  </v-list>

                </v-expansion-panel-content>
              </v-expansion-panel>
              
            </v-expansion-panels>

<!-- STATUS HISTORY BLOCK START  -->
            <v-card-title>
              <v-chip color="#15336d" text-color="white" label>
                <v-icon left>mdi-plus-network</v-icon>
                {{$t('ModalCard.status_change_history')}}
              </v-chip>
            </v-card-title>
            <v-timeline :dense="true" x-small>
              <template>
                <v-timeline-item
                  x-small
                  color="#15336d"
                  v-for="(item, index, i) in GETTERS_INPUT_ALL.status"
                  :key="i"
                >

                  <template>
                    <strong
                      style="color:#15336d"
                    >{{item.status_name}}</strong>
                    <v-chip color="#15336d" text-color="white">
                      <v-icon left>mdi-calendar-today</v-icon>
                      {{g.toDate(item.date)}}
                    </v-chip>
                    <v-chip color="#15336d" outlined v-if="(item.status_slug !== 'statement') || editable.can_see_expert">
                      <v-icon left>mdi-account-circle</v-icon>
                      {{item.init_by.last_name}}
                      {{item.init_by.first_name}}
                      {{item.init_by.middle_name}}
                    </v-chip>
                    <br />
                    <template>
                      <br />
                      <v-card>
                        <v-list subheader v-if="item.comments !== null">
                          <v-subheader>
                            <b>
                              <v-icon>mdi-comment-processing-outline</v-icon>
                              {{(item.status_slug == 'statement' && item.mark > 0) ? $t('ModalCard.comment_from_expert') : $t('comment')}}
                            </b>
                          </v-subheader>
                          <div class="comment-expert">
                            <template>
                              <v-list-item>
                                <div class="d-flex flex-column align-start">
                                  <div v-if="(item.status_slug === 'statement' && item.mark > 0)">
                                    <v-rating :readonly="true" :size="25" color="red" :value="item.mark"></v-rating>
                                    <p v-if="editable.can_see_expert">
                                      {{$t('ModalCard.expert')}}: {{item.init_by.last_name}} {{item.init_by.first_name}} {{item.init_by.middle_name}}
                                    </p>
                                    <br />
                                  </div>
                                    {{item.comments | filterEmpty}}
                                </div>
                              </v-list-item>
                            </template>
                          </div>
                        </v-list>
                      </v-card>
                    </template>
                    <template>
                      <v-card v-if="item.status_slug === 'scheduled'">
                        <v-list subheader>
                          <v-subheader>
                            <b>
                              <v-icon>mdi-timetable</v-icon>
                              {{$t('ModalCard.date_time_experiment')}}
                            </b>
                          </v-subheader>
                          <div v-if="GETTERS_INPUT_ALL.experiments.length !== 0">
                            <template v-for="(dtem, j) in GETTERS_INPUT_ALL.experiments">
                              <div style="color:#15336d">
                                <!-- <v-list-item>Назначил эксперимент: {{dtem.name !== null ? dtem.name : 'Имя отсутствует' }}</v-list-item> -->
                                <v-list-item >{{$t('planned')}}: {{g.toDate(dtem.created_at)}}</v-list-item>
                                <v-list-item v-for="(jtem, i) in dtem.calendar" :key="i">
                                  {{$t('interval')}} {{i}} : {{g.toDate(jtem.start_date)}} - {{g.toDate(jtem.finish_date)}}
                                  <br />
                                </v-list-item>
                              </div>
                            </template>
                          </div>
                        </v-list>
                      </v-card>
                    </template>
                  </template>
                </v-timeline-item>
              </template>
            </v-timeline>
          </v-card-text>
        </div>

        <div style="margin-left: 10px; width:28%;" class="suggested">

  <!-- MAIN INFO BLOCK START  -->

          <h2 style="margin-bottom: 0px;">{{ GETTERS_INPUT_ALL.author }} </h2>
          <h4 style="margin-top: 0px;">{{ GETTERS_INPUT_ALL.organisation }} email:{{ GETTERS_INPUT_ALL.applicant ? GETTERS_INPUT_ALL.applicant.email : '-' }} </h4>

          <p class="subtitle-2 text-left">
            <v-badge color="red lighten-2" :content="$t('ModalCard.type')" x-small overlap>
              <v-chip :color="$mainColor" text-color="white">
                <v-avatar left>
                  <v-icon color="white">mdi-beaker</v-icon>
                </v-avatar>
                <b
                  v-if="GETTERS_INPUT_ALL.scientific_subjects"
                  style="color:white;"
                >{{GETTERS_INPUT_ALL.scientific_subjects.name}}</b>
                <b v-else style="color:white;">{{$t('ModalCard.absent')}}</b>
              </v-chip>
            </v-badge>
          </p>
          <p class="subtitle-2 text-left">
            <v-badge color="red lighten-2" :content="$t('ModalCard.station')" x-small overlap>
              <v-chip :color="$mainColor" text-color="white">
                <v-avatar left>
                  <v-icon color="white">mdi-google-circles</v-icon>
                </v-avatar>
                <b
                  v-if="GETTERS_INPUT_ALL.stations.length !== 0"
                  style="color:white;"
                >{{GETTERS_INPUT_ALL.stations[0].name}}</b>
                <b v-else style="color:white;">{{$t('ModalCard.not_specified')}}</b>
              </v-chip>
            </v-badge>
          </p>

  <!-- EXPERTS         -->
          <p class="subtitle-2 text-left" v-if="experts.length>0 && editable.can_see_expert">
            <div v-for="(item, exp_index) in experts">
              <v-badge color="red lighten-2" :content="$t('ModalCard.expert')" x-small overlap>
                <v-chip :color="$mainColor" text-color="white">
                  <b>
                    <span style="color:white !important;">
                      {{item.expert_descr}}
                    </span>
                  </b>
                </v-chip>
              </v-badge>
              <div v-if="!expert_rating_mode || item.id != editable_id">
                <v-row class="mr-4">
                  <v-col cols="10" class="pt-0 pb-0">
                    <v-rating
                      v-model="item.mark"
                      readonly
                      half-increments
                    ></v-rating>
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0">
                    <v-badge
                      overlap
                    >
                    <template v-slot:badge>
                      <!-- <p style="font-size: 10px;">tot.: </p> -->
                      <p class="white--text" style="font-size: 10px; margin-top: -8px !important;">tot.: </p>
                      <!-- <span class="white--text">tot.:</span> -->
                    </template>

                    <v-avatar
                      :color="slider_color(item.mark)"
                      size="30"
                    >
                      <span class="white--text text-h5">{{ item.mark }}</span>
                    </v-avatar>
                    </v-badge>
                  </v-col>
                  <!-- <v-col cols="2" class="pt-0 pb-0">
                    <p style="font-size: medium; padding-top: 8px;">{{ item.mark }}</p>
                  </v-col> -->
                </v-row>
                <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="item.mark1"
                        :thumb-color="slider_color(item.mark1)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      >
                    </v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark1 }} : Научное содержание и Научный задел</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="item.mark2"
                        :thumb-color="slider_color(item.mark2)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark2 }} : Ожидаемые результаты</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="item.mark3"
                        :thumb-color="slider_color(item.mark3)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark3 }} : План эксперимента</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="item.mark4"
                        :thumb-color="slider_color(item.mark4)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark4 }} : Описание образцов</p>
                  </v-row>


                <span class="pb-3" v-if="item.comment != null && item.comment.length > 0">
                  <v-icon>mdi-comment-text</v-icon>
                    "{{item.comment}}"
                  <br />
                </span>
              </div>
              <div v-if="item.is_my && editable.buttons.can_change_expertise">
                <div v-if="expert_rating_mode">
                  <h4 v-if="GETTERS_INPUT_ALL.last_status_id == 3">{{$t('Actions.expert_rate_comment')}}</h4>
                  <v-row class="mb-4">
                    <v-col cols="2" class="pt-0 pb-0">
                      <v-badge
                        overlap
                      >
                      <template v-slot:badge>
                        <!-- <p style="font-size: 10px;">tot.: </p> -->
                        <p class="white--text" style="font-size: 10px; margin-top: -8px !important;">tot.: </p>
                        <!-- <span class="white--text">tot.:</span> -->
                      </template>

                      <v-avatar
                        :color="slider_color(new_expert_rating)"
                        size="30"
                      >
                        <span class="white--text text-h5">{{ new_expert_rating }}</span>
                      </v-avatar>
                      </v-badge>
                    </v-col>
                    <v-col cols="10" class="pt-0 pb-0">
                      <v-rating
                        :value="parseFloat(new_expert_rating)"
                        readonly
                        half-increments
                      ></v-rating>
                    </v-col>
                  </v-row>
                  <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="expert_rating_1"
                        :thumb-color="slider_color(expert_rating_1)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                      >
                    </v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>Научное содержание и Научный задел</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="expert_rating_2"
                        :thumb-color="slider_color(expert_rating_2)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>Ожидаемые результаты</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="expert_rating_3"
                        :thumb-color="slider_color(expert_rating_3)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>План эксперимента</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="expert_rating_4"
                        :thumb-color="slider_color(expert_rating_4)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>Описание образцов</p>
                  </v-row>

                  <div class="mr-3">
                    <v-textarea
                      class="bs-actions__textarea"
                      v-model="new_expert_comment"
                      outlined
                      color="#15336d"
                      name="input-7-4"
                      label="Комментарий"
                      rows="9"
                    ></v-textarea>
                  </div>
                </div>
                <v-btn v-if="!expert_rating_mode"
                  @click="make_rating_editable(item)"
                  outlined
                  width="80%"
                >{{ item.mark && item.mark > 0 ? 'Изменить оценку' : $t('ModalCard.expert_council') }}
                </v-btn>
                <div class="my-2"  v-if="expert_rating_mode">
                  <v-btn
                    outlined
                    @click="expert_rating_mode = false"
                    width="40%"
                    color="#15336d"
                    class="mr-2"
                  >{{$t('cancel')}}
                  </v-btn>
                  <v-btn
                    outlined
                    :disabled="!new_expert_comment || new_expert_comment.length === 0 || new_expert_rating == 0"
                    @click="expertise_proposal(item.id)"
                    width="40%"
                    color="#15336d">{{$t('Actions.save')}}
                  </v-btn>
                </div>
                <v-spacer style="height:15px;"></v-spacer>
              </div>
            </div>
          </p>
          <div class="subtitle-2" v-if="editable.buttons.expert_history">
            <div style="margin-bottom: 12px; cursor: pointer">
              <span  class="my-green" @click="load_experts_history()">
                <v-icon class="my-green">mdi-history</v-icon>
                история экспертной оценки
                <br />
              </span>
            </div>
          </div>


          <div class="subtitle-2">
            <b>{{$t('ModalCard.previous_applications')}}</b>
            <br />
            <div style="padding-right:30px;" v-if="GETTERS_INPUT_ALL.previous_proposals.length>0">
              <span
                style="font-size: 10px; cursor: pointer;"
                v-for="(item, index) in GETTERS_INPUT_ALL.previous_proposals"
                :key="index"
                @click="open_previous_proposal(item.id)"
              >
                <v-icon>mdi-arrow-left-bold-hexagon-outline</v-icon>
                №{{item.id}} "{{item.name}}"
                <br />
              </span>
            </div>
            <span v-else>{{$t('ModalCard.absent')}}</span>
          </div>
          <div class="subtitle-2">
            <b>Пучковое время :</b>
            <br />
            <div style="padding-right:30px;">
              <span>
                <v-icon>mdi-alarm</v-icon>
                запрошено : "{{GETTERS_INPUT_ALL.experiment_duration}}"
                <br />
              </span>
              <span v-if="
                    GETTERS_INPUT_ALL.last_status_id == statuses.Approve
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Scheduled
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Need_report
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Done
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Publication
              ">
                <v-icon>mdi-alarm-check</v-icon>
                предоставлено : "{{GETTERS_INPUT_ALL.provided_experiment_duration ? GETTERS_INPUT_ALL.provided_experiment_duration : 'не определено'}}"
                <br />
              </span>
            </div>
          </div>

          <div class="subtitle-2" style="align-items: flex-start;">
            <b>Предпочтительные даты эксперимента :</b>
            <div class="date-interval d-flex justify-space-between">
              {{formate_dateinterval(GETTERS_INPUT_ALL.experiment_calendar)}}
            </div>
          </div>

  <!-- EDIT BLOCK START  -->
          <template v-if="editable.can_edit">
            <Actions
              @closeProposalDialog="close_proposal_dialog()"
              @reloadParent="$emit('reloadParent', $event)"
              @reloadLists="$emit('reloadLists', $event)"
              @reloadCalendar="$emit('reloadCalendar', $event)"
              :id="GETTERS_INPUT_ALL.id"
              :editable="editable"
            />
            <v-card-text></v-card-text>
            <!--вынести в модуль-->

            <template v-if="editable.buttons.bs_change_experimental_plan">
              <v-spacer style="height:10px;"></v-spacer>
              <v-list-item>
                <template>
                  <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                    <v-btn
                    @click="change_experimental_plan_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >Изменить план</v-btn>
                  </div>
                </template>
              </v-list-item>
            </template>


            <template v-if="editable.buttons.bs_done_proposal">
              <v-spacer style="height:10px;"></v-spacer>
              <v-list-item>
                <template>
                  <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                    <v-btn
                    @click="done_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{$t('ModalCard.done_proposal')}}</v-btn>
                  </div>
                </template>
              </v-list-item>
            </template>


          </template>

          <template>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.silent_next_step">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-btn
                    @click="silent_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"'тихая' смена статуса"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.revision">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-btn
                    @click="revision_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"Отправить на доработку"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.msc_change_experimental_plan">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-btn
                    @click="msc_change_experimental_plan_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"Отправить заявителю"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.change_station">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-btn
                    @click="change_station_dialog = true, dialog_comment='', new_station = GETTERS_INPUT_ALL.stations[0].id"
                    outlined
                    width="100%"
                  >{{"Изменить станцию"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-list-item v-if="editable.buttons.extend_session_time">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-spacer style="height:10px;"></v-spacer>
                  <v-btn
                    @click="extend_session_time_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"продлить сессию"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.add_time">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-spacer style="height:10px;"></v-spacer>
                  <v-btn
                    @click="add_time_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"Добавить время"}}</v-btn>
                </div>
              </template>
            </v-list-item>
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item v-if="editable.buttons.set_not_realized">
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-spacer style="height:10px;"></v-spacer>
                  <v-btn
                    @click="set_not_realized_dialog = true, dialog_comment=''"
                    outlined
                    width="100%"
                  >{{"Не реализована"}}</v-btn>
                </div>
              </template>
            </v-list-item>

          </template>

          <template v-if="editable.can_export" style="padding-right:30px; width:100%;">
              <v-list-item style="margin-right:30px; ">
                <v-btn
                  style="margin-right:30px; margin-top:15px;"
                  @click="redirectPDFDocument()"
                  :disabled="GETTERS_INPUT_ALL.id.length === 0"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-file-pdf</v-icon>
                  {{$t('ModalCard.PDF_application')}}
                </v-btn>
              </v-list-item>
          </template>
        </div>
      </div>


      <v-dialog v-model="revision_dialog" persistent max-width="60%">
        <v-card>
          <v-card-title class="headline">{{ $t('ModeratorList.confirm_status_change') }}
          </v-card-title>
          <v-card-text>{{ $t('ModalCard.want_change_status_application_numbers') }} {{ $t('ModalCard.send_revision') }}
            {{ this.GETTERS_INPUT_ALL.id }}?
          </v-card-text>

          <v-list-item-title class="help-step modal-mul-select">
            {{ 'Что доработать' }}
          </v-list-item-title>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="reasons"
              :items="reasonsList.revision"
              item-text="name"
              item-value="name"
              outlined
              chips
              required
              multiple
            ></v-select>
          </div>

          <v-card-text>
            <v-textarea
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              :label="$t('comment')"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="revision_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="revision_proposal()">{{ "Отправить заявку на доработку" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="change_experimental_plan_dialog" persistent max-width="60%">
        <v-card>
          <v-card-title class="headline">Запрос на изменение плана эксперимента
          </v-card-title>
          <v-card-text>Руководитель по мегаустановке рассмотрит запрос и примет решение по отправке заявки на доработку заявителю.
          </v-card-text>

          <v-card-text>
            <v-textarea
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              label="Заполните обоснование"
              counter="1000"
              maxLength="1000"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="change_experimental_plan_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="bs_change_experimental_plan()">Отправить руководителю по мегаустановке
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="msc_change_experimental_plan_dialog" persistent max-width="60%">
        <v-card>
          <v-card-title class="headline">{{ $t('ModeratorList.confirm_status_change') }}
          </v-card-title>
          <v-card-text>Вы действительно хотите отправить заявителю для корректировки плана эксперимента заявку
            {{ this.GETTERS_INPUT_ALL.id }}?
          </v-card-text>
          <v-card-text>
            Обоснование ответственного по станции: {{ this.GETTERS_INPUT_ALL.change_plan_reason }}
          </v-card-text>
          <v-card-text>
            <v-textarea
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              label="Комментарий для заявителя"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="msc_change_experimental_plan_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="msc_change_experimental_plan_proposal()"> Отправить заявителю для корректировки плана эксперимента
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="done_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline">{{ $t('ModeratorList.confirm_status_change') }}
          </v-card-title>
          <v-card-text>{{ $t('ModalCard.want_change_status_application_numbers') }} {{$t('ModalCard.set_as_done')}}
            {{ this.GETTERS_INPUT_ALL.id }}?
          </v-card-text>

          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              :label="$t('comment')"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="done_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="done_proposal()">{{$t('ModalCard.done_proposal')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="silent_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline">'тихая' смена статуса
          </v-card-title>
          <v-card-text>выберите новый статус для
            {{ this.GETTERS_INPUT_ALL.id }}:
          </v-card-text>

          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="silent_new_status"
              :items="silent_new_statuses"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>

          <v-list-item-title class="help-step modal-mul-select">дата смены статуса : </v-list-item-title>
          <div class="input-container input-name modal-mul-select">
            <v-date-picker
              v-model="silent_date"
              :allowed-dates="allowedDates"
              class="mt-4"
              min="2021-01-01"
              max="2028-12-31"
            ></v-date-picker>
          </div>

          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              :label="$t('comment')"
            ></v-text-field>
          </v-card-text>

          <v-list-item-title>{{$t('file-upload.text')}}</v-list-item-title>
            <v-file-input
                v-model="file"
                label="Добавить файл"
                color="#15336d"
                :success="loadedFile"
                :loading="loadedFile"
                prepend-icon="mdi-paperclip">
              </v-file-input>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="silent_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="silent_proposal()">{{"изменить"}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="change_station_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline"> Изменить станцию
          </v-card-title>
          <v-card-text>Выберите новую станцию для заявки
            {{ this.GETTERS_INPUT_ALL.id }}:
          </v-card-text>

          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="new_station"
              :items="GETTERS_STATIONS"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>

          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              :label="$t('comment')"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="change_station_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="change_station()">{{"изменить"}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="add_time_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline"> Добавить пучковое время заявке {{ this.GETTERS_INPUT_ALL.id }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="9">
                <v-text-field
                  v-model="additional_experiment_duration"
                  outlined
                  required
                  name="input-7-4"
                  suffix="часов"
                  type="number"
                  label="Предоставленное дополнительное пучковое время"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              label="Причина"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="add_time_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="add_time()">{{"Добавить"}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="extend_session_time_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline"> Продлить срок выполнения заявки {{ this.GETTERS_INPUT_ALL.id }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-list-item-title class="help-step modal-mul-select">Срок выполнения заявки продлить до : </v-list-item-title>
            </v-row>
            <v-row>
              <div class="input-container input-name modal-mul-select">
                <v-date-picker
                  v-model="new_proposal_session_end"
                  class="mt-4"
                  min="2025-06-31"
                  no-title
                  scrollable
                  first-day-of-week="1"
                  locale='ru-RU'
                ></v-date-picker>
              </div>
            </v-row>

          </v-card-text>

          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              label="Причина"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="extend_session_time_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="extend_session_time()">{{"Сохранить"}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="set_not_realized_dialog" persistent max-width="40%">
        <v-card>
          <v-card-title class="headline"> Перевести заявку {{ this.GETTERS_INPUT_ALL.id }} в статус "не реализована"
          </v-card-title>

          <v-list-item-title class="help-step modal-mul-select">Укажите причину отмены выполнения заявки</v-list-item-title>
          <v-list-item-title class="help-step modal-mul-select">Комментарий буден виден заявителю, будьте аккуратны)</v-list-item-title>
          <v-card-text>
            <v-text-field
              v-model="dialog_comment"
              outlined
              required
              name="input-7-4"
              label="Причина"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="set_not_realized_dialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="green darken-1" text
              @click="set_not_realized()">{{"Подтвердить"}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="expert_history_dialog" max-width="50%">
        <v-card>
          <v-card-title class="headline">История экспертных оценок
          </v-card-title>

          <v-card-text v-if="expert_history.length > 0">
            <div v-for="item in expert_history" :key="item.id">
              <v-row>
                <v-col cols="4" class="pt-0 pb-0">
                  <v-badge color="red lighten-2" :content="(item.date.split('T'))[0].split('-').reverse().join('.')" x-small overlap>
                    <v-chip :color="$mainColor" text-color="white">
                      <b>
                        <span style="color:white !important;">
                          {{item.expert_descr}}
                        </span>
                      </b>
                    </v-chip>
                  </v-badge>
                </v-col>
                <v-col cols="2" class="pt-0 pb-0">
                  <v-badge
                    overlap
                  >
                  <template v-slot:badge>
                    <!-- <p style="font-size: 10px;">tot.: </p> -->
                    <p class="white--text" style="font-size: 10px; margin-top: -8px !important;">tot.: </p>
                    <!-- <span class="white--text">tot.:</span> -->
                  </template>

                  <v-avatar
                    :color="slider_color(item.mark)"
                    size="30"
                  >
                    <span class="white--text text-h5">{{ item.mark }}</span>
                  </v-avatar>
                  </v-badge>
                </v-col>
                <!-- <v-col cols="1" class="pt-0 pb-0">
                  <p style="font-size: medium; padding-top: 8px;">{{ item.mark }}</p>
                </v-col> -->
                <v-col cols="6" class="pt-0 pb-0">
                  <v-rating
                    v-model="item.mark"
                    readonly
                    half-increments
                  ></v-rating>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                <span class="pb-3" v-if="item.comment != null && item.comment.length > 0">
                  <v-icon>mdi-comment-text</v-icon>
                    "{{item.comment}}"
                  <br />
                </span>
                </v-col>
                <v-col cols="7">
                  <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="item.mark1"
                        :thumb-color="slider_color(item.mark1)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      >
                    </v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark1 }} : Научное содержание и Научный задел</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="item.mark2"
                        :thumb-color="slider_color(item.mark2)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark2 }} : Ожидаемые результаты</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                    <v-slider
                        v-model="item.mark3"
                        :thumb-color="slider_color(item.mark3)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled 
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark3 }} : План эксперимента</p>
                  </v-row>

                  <v-row style="margin-bottom: -40px;" class="mr-4">
                      <v-slider
                        v-model="item.mark4"
                        :thumb-color="slider_color(item.mark4)"
                        thumb-label="always"
                        :thumb-size="20"
                        step="0.1"
                        min="0"
                        max="5"
                        disabled
                      ></v-slider>
                  </v-row>
                  <v-row class="ml-4">
                    <p>{{ item.mark4 }} : Описание образцов</p>
                  </v-row>
                </v-col>
              </v-row>
              </div>
          </v-card-text>
          <v-card-text v-else>
            <p>Экспертная оценка еще не проводилась</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="expert_history_dialog = false">закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Actions from "./modalCardActions.vue";
import ScheduleProposalCard from "./scheduleProposalCard.vue";
import {ProposalStatus} from '../../../store/proposalStatus.js'
import { DOMEN } from '../../../../vars';

export default {
  name: 'modalCard',
  components: {
    Actions,
    ScheduleProposalCard,
  },
  props: {
    comment: String,
    from_pass_card: Boolean,
  },
  data() {
    return {
      loadingComment: false,
      commentBsCard: '',
      opened_panels:[0,8,9],
      statuses: null,
      editable: {
        can_edit : false,
        can_export : false,
        buttons : {
          revision : false,
          accept_application : false,
          examination : false,
          next_step : false,
        }
      },
      dialog_comment: '',
      revision_dialog: false,
      reasonsList: {
        reject : [
          {id: 1, name : 'Не раскрыто научное содержание'},
          {id: 2, name : 'Не указана новизна'},
          {id: 3, name : 'По формальному признаку. Некорректно заполнены поля заявки'},
          {id: 4, name : 'Низкая научная значимость'},
          {id: 5, name : 'Отсутствует описание/характеристики образца'},
          {id: 6, name : 'Не обоснован выбор метода исследования'},
          {id: 7, name : 'Не представлен план эксперимента'}
        ],
        revision : [
          {id: 1, name : 'научное содержание'},
          {id: 2, name : 'обозначить связь с предыдущими экспериментами'},
          {id: 3, name : 'раскрыть более детально ожидаемые результаты и область их пременения'},
          {id: 4, name : 'планируемый результат'},
          {id: 5, name : 'описание/характеристики образца'},
          {id: 6, name : 'представить детальный план эксперимента'},
          {id: 7, name : 'указать новизну предполагаемого иссследования'}
        ],
      },
      reasons: null,
      done_dialog: false,
      silent_dialog: false,
      change_station_dialog: false,
      add_time_dialog: false,
      extend_session_time_dialog: false,
      set_not_realized_dialog: false,
      change_experimental_plan_dialog: false,
      msc_change_experimental_plan_dialog: false,
      expert_history_dialog: false,
      expert_history: [],
      additional_experiment_duration: 0,
      silent_date: null,
      silent_new_status: null,
      last_status_date: null,
      silent_new_statuses: [
        {id: 1, name : '1: Черновик'},
        {id: 2, name : '2: Входящие заявки'},
        {id: 8, name : '8: Ожидает отчёта'},
        {id: 9, name : '9: Выполнена'},
        {id: 10, name : '10: Статья'},
      ],
      loadedFile: false,
      file: null,
      checkFile: false,
      file_id: null,
      new_station: null,
      experts: [],
      expert_rating_mode: false,
      new_expert_comment: '',
      editable_id: 0,
      proposals_id_stack: [],
      new_expert_rating: 0,
      expert_rating_1: 0,
      expert_rating_2: 0,
      expert_rating_3: 0,
      expert_rating_4: 0,

      can_bs_edit: true,
      eqiupment_edit_mode: false,
      applicant_equipment_approved_new: '',
      new_proposal_session_end: null,
    };
  },

  beforeMount() {
    this.statuses = ProposalStatus;
    this.load_editable();
  },

  computed: {
    ...mapGetters([
      'GETTERS_INPUT_ALL',
      'GETTERS_STATIONS',
      'GETTERS_STATION_BY_ID',
      'GETTERS_SAMPLETYPES',
      'GETTERS_BASE_PROPOSAL_ID',
    ]),
  },
  methods:  {
    ...mapActions([
      'ADD_COMMENT_BS_CARD',
      'PROPOSAL_BS_ACTION_CARD',
      'GET_PROPOSAL_AVAILABLE_ACTIONS',
      'UPDATE_PROPOSAL_STATUS',
      'EXPERTISE_PROPOSAL',
      'FILE_SEND',
      'GET_PROPOSAL_EXPERTS',
      'GET_URL_PRD',
      'GET_INPUT_ALL',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    slider_color(val){
      if(val < 2.6)
        return '#a63a0d'
      else if(val > 4)
        return '#0da635'
      else
        return '#a69d0d'
    },

    make_rating_editable(item){
      this.expert_rating_mode = true;
      this.new_expert_rating = item.mark > 0 ? item.mark : 0
      this.expert_rating_1 = item.mark1 > 0 ? item.mark1 : 0
      this.expert_rating_2 = item.mark2 > 0 ? item.mark2 : 0
      this.expert_rating_3 = item.mark3 > 0 ? item.mark3 : 0
      this.expert_rating_4 = item.mark4 > 0 ? item.mark4 : 0
      this.new_expert_comment = item.comment
      this.editable_id = item.id
    },

    close_proposal_dialog(){
      this.proposals_id_stack = [];
      this.$emit('closeProposalDialog');
    },

    open_previous_proposal(proposal_id){
      this.proposals_id_stack.push(this.GETTERS_INPUT_ALL.id)
      this.UPDATE_OVERLAY(true)
      this.GET_INPUT_ALL(proposal_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
    },

    back_proposal(){
      var prev_id = this.proposals_id_stack.pop()
      if(prev_id > 0){
        this.UPDATE_OVERLAY(true)
        this.GET_INPUT_ALL(prev_id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
        })
      }
    },

    reload_proposal(){
      this.UPDATE_OVERLAY(true)
      this.GET_INPUT_ALL(this.GETTERS_INPUT_ALL.id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
    },

    change_applicant_equipment(val){
      this.UPDATE_OVERLAY(true)
      this.PROPOSAL_BS_ACTION_CARD({
        'action': 'change_applicant_equipment',
        'proposal_id': this.GETTERS_INPUT_ALL.id,
        'applicant_equipment_approved_new': this.applicant_equipment_approved_new,
      })
      .then((data) => {
        this.eqiupment_edit_mode = false

        this.reload_proposal()
      })

    },

    redirectPDFDocument() {
      this.UPDATE_OVERLAY(true)
      this.GET_URL_PRD(this.GETTERS_INPUT_ALL.id)
        .then(() => this.UPDATE_OVERLAY(false))
        .catch(() => this.UPDATE_OVERLAY(false));
    },

    openFile(fileName) {
      window.open(DOMEN + `/media/${fileName}`, '_blank')
    },

    comment_background_color(item){
      if(item.kind === 'bs' && item.bs_resolution == 1)
        return 'red_bg'
      if(item.kind === 'bs' && item.bs_resolution == 2)
        return 'green_bg'
      else
        return ''
    },

    load_editable(){
      this.experts = [];
      this.eqiupment_edit_mode = false;
      this.expert_rating_mode = false;

      this.GET_PROPOSAL_AVAILABLE_ACTIONS(this.GETTERS_INPUT_ALL.id).then(res => {
        this.editable = res
        if(this.GETTERS_INPUT_ALL.last_status_id > 2 && this.GETTERS_INPUT_ALL.last_status_id != 6 && this.editable.can_see_expert){
          this.GET_PROPOSAL_EXPERTS({proposal_id: this.GETTERS_INPUT_ALL.id, view_type: 'current'})
            .then(res => {
              this.experts = res
            })
        }
      })
      this.last_status_date = this.GETTERS_INPUT_ALL.status[this.GETTERS_INPUT_ALL.status.length - 1].date.substr(0,10)
    },

    bs_change_experimental_plan(){
      if (!this.dialog_comment.length){
        this.$messageHelper(this.$t('leave_comment'), 'error', 3000);
        return;
      }

      this.updateStatus({
        proposal_id: this.GETTERS_INPUT_ALL.id,
        proposal_action: 'bs_change_experimental_plan',
        comment: this.dialog_comment,
      });
    },

    msc_change_experimental_plan_proposal(){
      if (!this.dialog_comment.length){
        this.$messageHelper(this.$t('leave_comment'), 'error', 3000);
        return;
      }

      this.$emit('reloadParent')
      this.$emit('reloadLists')

      this.updateStatus({
        proposal_id: this.GETTERS_INPUT_ALL.id,
        proposal_action: 'msc_change_experimental_plan',
        comment: this.dialog_comment,
      });
    },

    revision_proposal(){
      if (!this.reasons && !this.dialog_comment.length){
        this.$messageHelper(this.$t('leave_comment'), 'error', 3000);
        return;
      }

      let dataUpdateStatus = {};
      
      var full_comment = 'Необходимо доработать: ';

      if(this.reasons && this.reasons.length){
        this.reasons.forEach((item, i) => {
          full_comment += ( (!i ? ' ' :', ') + item);
        });
        full_comment += '.';
      }
      full_comment += (' ' + this.dialog_comment);


      dataUpdateStatus = {
        proposal_id: this.GETTERS_INPUT_ALL.id,
        proposal_action: 'revision',
        comment: full_comment,
      };

      this.$emit('reloadParent')
      this.$emit('reloadLists')

      this.updateStatus(dataUpdateStatus);
    },

    done_proposal(){
      let dataUpdateStatus = {
        proposal_id: this.GETTERS_INPUT_ALL.id,
        proposal_action: 'need_report',
        comment: this.dialog_comment,
      };

      this.$emit('reloadParent')
      this.$emit('reloadLists')

      this.updateStatus(dataUpdateStatus);
    },

    allowedDates(val){
      return true
      //  return (val >= this.last_status_date)
    },

    formate_dateinterval(str){
      if(str == null || str.length == 0)
        return 'Не указаны'

      var dates = str.split(':')
      if(dates[0] == 'undefined')
        return 'Не указаны'

        dates[0] = dates[0].split('-').reverse().join('.')
        dates[1] = dates[1].split('-').reverse().join('.')
      return dates[0] + ' : ' + dates[1]
    },

    silent_proposal(){
      this.file_id = null;
      if (!this.silent_new_status){
        this.$messageHelper('Укажите новый статус', 'error', 3000);
        return;
      }
      if (!this.silent_date){
        this.$messageHelper('Укажите дату', 'error', 3000);
        return;
      }
      if(this.file){
        this.saveFile()
      }
      else{
        this.silentUpdateStatus()
      }
    },

    silentUpdateStatus(){
      let dataUpdateStatus = {
        proposal_action: 'silent',
        proposal_id: this.GETTERS_INPUT_ALL.id,
        new_status_id: this.silent_new_status,
        date: this.silent_date,
        comment: this.dialog_comment,
      };
      if(this.file_id > 0){
        dataUpdateStatus['file_id'] = this.file_id
      }

      this.$emit('reloadParent')
      this.$emit('reloadLists')

      this.updateStatus(dataUpdateStatus);
    },

    set_not_realized(){
      if (!this.dialog_comment){
        this.$messageHelper('Укажите причину', 'error', 3000);
        return;
      }
      else{
        let dataUpdateStatus = {
          proposal_action: 'set_not_realized',
          proposal_id: this.GETTERS_INPUT_ALL.id,
          comment: this.dialog_comment,
        };

        this.$emit('reloadParent')
        this.$emit('reloadLists')

        this.updateStatus(dataUpdateStatus);
      }

    },

    saveFile() {
      if(this.checkFile) {
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);
        files.append('proposal_id', this.GETTERS_INPUT_ALL.id)
        if(this.silent_new_status == 9)
          files.append('type', 1) // report
          if(this.silent_new_status == 10)
          files.append('type',  2) // publication

        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.file_id = res.data.id
            this.silentUpdateStatus()
          })
          .catch(() => this.loadedFile = false)
      }

    },

    expertise_proposal(id){
      let dataUpdateStatus = {
        id: id,
        proposal_id: this.GETTERS_INPUT_ALL.id,
        mark: parseFloat(this.new_expert_rating),
        mark1: this.expert_rating_1,
        mark2: this.expert_rating_2,
        mark3: this.expert_rating_3,
        mark4: this.expert_rating_4,
        comment: this.new_expert_comment,
      };

      this.UPDATE_OVERLAY(true)
      this.EXPERTISE_PROPOSAL(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.$emit('reloadParent');
            this.$messageHelper(this.$t('success'), 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.response.data.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });
    },

    change_station(){
      if(this.new_station == this.GETTERS_INPUT_ALL.stations[0].id){
        this.$messageHelper('Выберите отличающуюся от текущей станцию', 'error', 3000)
        return
      }
      var comment = 'Смена станции: "' + this.GETTERS_INPUT_ALL.stations[0].name + '" - "' + this.GETTERS_STATION_BY_ID(this.new_station).name + '". '
      comment = comment + this.dialog_comment

      let dataUpdateStatus = {
        proposal_action: 'change_station',
        proposal_id: this.GETTERS_INPUT_ALL.id,
        new_station_id: this.new_station,
        comment: comment,
      };

      this.$emit('reloadParent')
      this.$emit('reloadLists')
      this.$emit('reloadCalendar')

      this.updateStatus(dataUpdateStatus, true);
    },

    add_time(){
      if(this.additional_experiment_duration <= 0){
        this.$messageHelper('Укажите время', 'error', 3000)
        return
      }
      var comment = 'Добавлено пучковое время: ' + this.additional_experiment_duration + 'ч. '
      comment = comment + this.dialog_comment

      let dataUpdateStatus = {
        proposal_action: 'add_time',
        proposal_id: this.GETTERS_INPUT_ALL.id,
        additional_experiment_duration: this.additional_experiment_duration,
        comment: comment,
      };

      this.$emit('reloadParent')
      this.$emit('reloadLists')
      this.$emit('reloadCalendar')

      this.updateStatus(dataUpdateStatus, true);
    },

    extend_session_time(){
      if(this.new_proposal_session_end <= 0){
        this.$messageHelper('Укажите время', 'error', 3000)
        return
      }
      var comment = 'Срок выполнения заявки продлен до: ' + this.new_proposal_session_end + 'ч. '
      comment = comment + this.dialog_comment

      let dataUpdateStatus = {
        proposal_action: 'extend_session_time',
        proposal_id: this.GETTERS_INPUT_ALL.id,
        new_proposal_session_end: this.new_proposal_session_end,
        comment: comment,
      };
      
      this.$emit('reloadParent')
      this.$emit('reloadLists')
      this.$emit('reloadCalendar')

      this.updateStatus(dataUpdateStatus, true);
    },

    updateStatus(dataUpdateStatus, full_update_parent = false) {
      this.UPDATE_OVERLAY(true)

      this.UPDATE_PROPOSAL_STATUS(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.revision_dialog = false;
            this.done_dialog = false;
            this.silent_dialog = false;
            this.change_station_dialog = false;
            this.add_time_dialog = false;
            this.extend_session_time_dialog = false;
            this.set_not_realized_dialog = false;
            this.change_experimental_plan_dialog = false;
            this.msc_change_experimental_plan_dialog = false;

            this.$messageHelper(this.$t('ModeratorTab.successful_status_change'), 'success', 3000);
            
            this.reload_proposal()
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });
    },

    addCommentBs(item) {
      if (this.commentBsCard.length !== 0) {
          this.loadingComment = true
          this.ADD_COMMENT_BS_CARD({
                'kind': 'common',
                'text': this.commentBsCard,
                'user': localStorage.isLoggedIn,
                'proposal': this.GETTERS_INPUT_ALL.id
          })
          .then(res => {
            this.$messageHelper(`Комментарий добавлен`, 'success', 5000)
            this.commentBsCard = ''
            this.loadingComment = false
            
            this.$emit('reloadParent')
          })
      }
    },

    // _updateText: (str) => str.replace(/\n/g, '\u003cbr\u003e'),


    _updateText(str){
      var str2 = str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#x60;');
      str2 = str2.replace(/\n/g, '\u003cbr\u003e')
      return str2
    },

    validateFile(val) {
      const type = val.name.split('.').pop();

      if (
          type === 'doc' ||
          type === 'docx' ||
          type === 'pdf' ||
          type === 'jpg' ||
          type === 'png' ||
          type === 'pptx' ||
          type === 'ppt'
      ) {
        if (val.size <= 6291456) {

            this.checkFile =  true
        } else {
          this.$messageHelper(this.$t('Step2.6md'), 'error')
          this.checkFile = false
          this.file = ''

        }
      } else {
        this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        this.checkFile = false
        this.file = ''
      }
    },

    load_experts_history(){
      this.UPDATE_OVERLAY(true)
      this.GET_PROPOSAL_EXPERTS({proposal_id: this.GETTERS_INPUT_ALL.id, view_type: 'full'})
        .then((res) => {
          // console.log('load_experts_history', res)
          this.UPDATE_OVERLAY(false)
          this.expert_history_dialog = true;
          this.expert_history = res;
        })
        .catch(() => this.UPDATE_OVERLAY(false))
    },
  },

  watch:{
    expert_rating_1(val){
      this.new_expert_rating = ((this.expert_rating_1 + this.expert_rating_2 + this.expert_rating_3 + this.expert_rating_4)/4).toFixed(1)
    },
    expert_rating_2(val){
      this.new_expert_rating = ((this.expert_rating_1 + this.expert_rating_2 + this.expert_rating_3 + this.expert_rating_4)/4).toFixed(1)
    },
    expert_rating_3(val){
      this.new_expert_rating = ((this.expert_rating_1 + this.expert_rating_2 + this.expert_rating_3 + this.expert_rating_4)/4).toFixed(1)
    },
    expert_rating_4(val){
      this.new_expert_rating = ((this.expert_rating_1 + this.expert_rating_2 + this.expert_rating_3 + this.expert_rating_4)/4).toFixed(1)
    },

    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val)
      }
    },

    GETTERS_BASE_PROPOSAL_ID(val){
      this.proposals_id_stack = []
    },

    GETTERS_INPUT_ALL(val) {
      this.load_editable()
    },
  },

  filters: {
    filterType(val) {
      if (val.hasOwnProperty("individual"))
        return val.individual.first_name + " " + val.individual.last_name;
      if (val.hasOwnProperty("name")) return val.name;
      if (val.hasOwnProperty("status_name")) return val.status_name;
      if (val.hasOwnProperty("text")) return val.text;
      if (val === null) return this.$t("no_data");
      return val;
    },
    filterKeyOne(val) {
      if (val !== null && typeof val == "object") {
        if (val.hasOwnProperty("individual"))
          return val.individual.first_name + " " + val.individual.last_name;
        if (val.hasOwnProperty("name")) return val.name;
        if (val.hasOwnProperty("status_name")) return val.status_name;
        if (val.hasOwnProperty("text")) return val.text;
      }

      if (val === null) return this.$t("no_data");

      return val;
    },
    translateName(val) {
      if (val === "id") return "Номер заявки";
      if (val === "name") return "Название";
      if (val === "content") return "Текст";
      if (val === "background") return "Задел";
      if (val === "problem_formulation") return "Формулировка проблемы";
      if (val === "team_publications") return "Публикации коллектива";
      if (val === "experiment_strategy") return "Стратегия эксперимента";
      if (val === "expected_results") return "Ожидаемые результаты";
      if (val === "method") return "Методика";
      if (val === "meta") return "Мета-информация";
      if (val === "experiment_duration")
        return "Продолжительность эксперимента";
      if (val === "experiment_calendar") return "Желаемая дата эксперимента";
      if (val === "is_toxic") return "Токсичность";
      if (val === "is_different_dangerous") return "Другие опасности";
      if (val === "other_dangers") return "Другие опасности, комментарий";
      if (val === "applicant_id") return "Заявитель id";
      if (val === "expert") return "Эксперт";
      if (val === "team") return "Команда";
      if (val === "local_contacts") return "Локальный контакт";
      if (val === "scientific_subjects") return "Тематика";
      if (val === "comments") return "Коментарий";
      if (val === "files") return "Файлы";
      if (val === "stations") return "Станция";
      if (val === "previous_proposals") return "Предыдущая заявка";
      if (val === "applicant") return "Заявитель";
      if (val === "status") return "Статус";
      if (val === "current_status") return "Текущий статус";
      if (val === "can_work_at_night")
        return "Возможность работать в ночное время";
      if (val === "additional_equipment") return "Дополнительное оборудование";
      if (val === "is_biohazard") return "Биологическая опасность";
      return val;
    },
    filterEmpty(val) {
      if (val === null) return 'Отсутствует';
      else if (val === undefined) return 'Отсутствует';
      else if (val.length === 0) return 'Отсутствует';

      return val;
    },
    filterAuthor(val) {
      if (val === null) return this.$t('author') + ' ' + this.$t('absent');
      if (val.length === 0) return this.$t('author') + ' ' + this.$t('absent');

      return val;
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
}
.my-green{
  color:#62ba02 !important;
}
.main-card * {
  color: #15336d;
}
.comment-expert,
.comment-bs {
  overflow-y: auto;
}
.comment-expert {
  padding-top: 0;
}
.comment-bs *{
  color: #15336d !important;
}
.my-primary{
  color: #15336d !important;
}
.modal-mul-select{
    padding-top: 0px;
    padding-right: 24px;
    padding-bottom: 20px;
    padding-left: 24px;
}
</style>
